import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "user.auth_tokens.was_this_you"}}
  @closeModal={{@closeModal}}
>
  <:body>
    <div>
      <p>{{i18n "user.auth_tokens.was_this_you_description"}}</p>
      <p>{{html-safe (i18n "user.second_factor.extended_description")}}</p>
    </div>
    <div>
      <h3>{{i18n "user.auth_tokens.details"}}</h3>
      <ul>
        <li>{{d-icon "far-clock"}} {{format-date @model.seen_at}}</li>
        <li>{{d-icon "map-marker-alt"}} {{@model.location}}</li>
        <li>{{d-icon @model.icon}}
          {{i18n
            "user.auth_tokens.browser_and_device"
            browser=@model.browser
            device=@model.device
          }}</li>
      </ul>
    </div>

    {{#if this.latestPost}}
      <div>
        <h3>
          {{i18n "user.auth_tokens.latest_post"}}
          {{! when this.fetchActivity is called, the modal focus is reset }}
          {{! allowing you to tab behind the modal, so we need to refocus }}
          <a href {{on "click" this.toggleExpanded}} {{auto-focus}}>
            {{d-icon (if this.expanded "caret-up" "caret-down")}}
          </a>
        </h3>
        {{#if this.expanded}}
          <blockquote>{{html-safe this.latestPost.cooked}}</blockquote>
        {{else}}
          <blockquote>{{html-safe this.latestPost.excerpt}}</blockquote>
        {{/if}}
      </div>
    {{/if}}
  </:body>
  <:footer>
    <DButton
      class="btn-primary"
      @action={{@closeModal}}
      @icon="lock"
      @label="user.auth_tokens.secure_account"
    />
    <DModalCancel @close={{@closeModal}} />
  </:footer>
</DModal>
*/
{
  "id": "Cl9C2OdP",
  "block": "[[[8,[39,0],null,[[\"@title\",\"@closeModal\"],[[28,[37,1],[\"user.auth_tokens.was_this_you\"],null],[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[12],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"user.auth_tokens.was_this_you_description\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[[28,[37,1],[\"user.second_factor.extended_description\"],null]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[12],[1,\"\\n      \"],[10,\"h3\"],[12],[1,[28,[35,1],[\"user.auth_tokens.details\"],null]],[13],[1,\"\\n      \"],[10,\"ul\"],[12],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[\"far-clock\"],null]],[1,\" \"],[1,[28,[35,4],[[30,2,[\"seen_at\"]]],null]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[\"map-marker-alt\"],null]],[1,\" \"],[1,[30,2,[\"location\"]]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[[30,2,[\"icon\"]]],null]],[1,\"\\n          \"],[1,[28,[35,1],[\"user.auth_tokens.browser_and_device\"],[[\"browser\",\"device\"],[[30,2,[\"browser\"]],[30,2,[\"device\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"latestPost\"]],[[[1,\"      \"],[10,0],[12],[1,\"\\n        \"],[10,\"h3\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"user.auth_tokens.latest_post\"],null]],[1,\"\\n\"],[1,\"          \"],[11,3],[24,6,\"\"],[4,[38,6],[\"click\",[30,0,[\"toggleExpanded\"]]],null],[4,[38,7],null,null],[12],[1,\"\\n            \"],[1,[28,[35,3],[[52,[30,0,[\"expanded\"]],\"caret-up\",\"caret-down\"]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"expanded\"]],[[[1,\"          \"],[10,\"blockquote\"],[12],[1,[28,[35,2],[[30,0,[\"latestPost\",\"cooked\"]]],null]],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"blockquote\"],[12],[1,[28,[35,2],[[30,0,[\"latestPost\",\"excerpt\"]]],null]],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]],[[[1,\"\\n    \"],[8,[39,8],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,1],\"lock\",\"user.auth_tokens.secure_account\"]],null],[1,\"\\n    \"],[8,[39,9],null,[[\"@close\"],[[30,1]]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"html-safe\",\"d-icon\",\"format-date\",\"if\",\"on\",\"auto-focus\",\"d-button\",\"d-modal-cancel\"]]",
  "moduleName": "discourse/components/modal/auth-token.hbs",
  "isStrictMode": false
});